import React from "react";

export const SunIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="sun-icon"
    >
      <g clipPath="url(#clip0_14433_6338)">
        <path
          d="M9 13.5C6.51472 13.5 4.5 11.4853 4.5 9C4.5 6.51472 6.51472 4.5 9 4.5C11.4853 4.5 13.5 6.51472 13.5 9C13.5 11.4853 11.4853 13.5 9 13.5ZM8.25 0.75H9.75V3H8.25V0.75ZM8.25 15H9.75V17.25H8.25V15ZM2.63604 3.6967L3.6967 2.63604L5.28769 4.22703L4.22703 5.28769L2.63604 3.6967ZM12.7123 13.773L13.773 12.7123L15.364 14.3033L14.3033 15.364L12.7123 13.773ZM14.3033 2.63604L15.364 3.6967L13.773 5.28769L12.7123 4.22703L14.3033 2.63604ZM4.22703 12.7123L5.28769 13.773L3.6967 15.364L2.63604 14.3033L4.22703 12.7123ZM17.25 8.25V9.75H15V8.25H17.25ZM3 8.25V9.75H0.75V8.25H3Z"
          fill="#C8C8C9"
        />
      </g>
      <defs>
        <clipPath id="clip0_14433_6338">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
